import { render, staticRenderFns } from "./ProductServiceDetail.vue?vue&type=template&id=a155c3d6&scoped=true"
import script from "./ProductServiceDetail.vue?vue&type=script&lang=js"
export * from "./ProductServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceDetail.vue?vue&type=style&index=0&id=a155c3d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a155c3d6",
  null
  
)

export default component.exports